import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faUserPlus } from "@fortawesome/pro-regular-svg-icons";
import { FeedbackRequestDto } from "../../../types/feedback/FeedbackRequestDto";
import { isActiveFeedbackRequestStatus } from "../../../helpers/feedbackModeHelper";
import CoContributorNoteDto from "../../../types/feedback/CoContributorNoteDto";
import feedbackRequestApi from "../../../api/feedback/feedbackRequestApi";
import FeedbackRequestList from "./FeedbackRequestList";

interface FeedbackActionBarProps {
  requests: FeedbackRequestDto[];
  notes: CoContributorNoteDto[];
  isLoading: boolean;
  api: feedbackRequestApi;
  onRequestFeedbackClick: () => void;
  onRequestDeleted: () => void;
}

function FeedbackActionBar({
  requests,
  notes,
  isLoading,
  api,
  onRequestFeedbackClick,
  onRequestDeleted,
}: FeedbackActionBarProps) {
  const activeRequests = requests.filter((r) =>
    isActiveFeedbackRequestStatus(r.status),
  );
  const hasActiveRequests = activeRequests.length > 0;

  return (
    <div className="px-2 lg:px-4 mb-2 print:hidden">
      <div className="background-tint-bg border border-gray-200 rounded-md px-4 py-2.5">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2 text-sm text-gray-600">
            <FontAwesomeIcon icon={faUserPlus} className="text-gray-400" />
            {hasActiveRequests ? (
              <span className="font-semibold">
                {activeRequests.length} Feedback{" "}
                {activeRequests.length === 1 ? "Request" : "Requests"}
              </span>
            ) : (
              <span className="font-semibold">
                Invite someone to review and contribute feedback
              </span>
            )}
          </div>
          <button
            className="btn-primary text-sm !pl-2 !pr-3 py-1 inline-flex items-center"
            onClick={onRequestFeedbackClick}
          >
            <FontAwesomeIcon icon={faPlus} className="mr-1.5" />
            Request Feedback
          </button>
        </div>

        {hasActiveRequests && (
          <div className="mt-2 border-t border-gray-200 pt-2">
            <FeedbackRequestList
              requests={requests}
              notes={notes}
              isLoading={isLoading}
              api={api}
              onRequestDeleted={onRequestDeleted}
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default FeedbackActionBar;
